/**
 * @overview isObject
 * @author Amir Absalyamov <mr.amirka@ya.ru>
 */

module.exports = (v) => v && typeof v == 'object';
